import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
    createMuiTheme, Toolbar, Typography, CssBaseline, AppBar, Button,
    Checkbox, Snackbar, FormControl, FormControlLabel, Select, Fab
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import { Modules } from '../contexts/modulesContext';
import { TransactionTime } from '../common/transactionTime';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import StopIcon from '@material-ui/icons/Stop';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PatientSittingAdd from './patientSittingAdd';
import Grid from '@material-ui/core/Grid';
import AlertDialog from '../alertDialog/alertDialog.js';
import ContentDialog from '../common/contentDialog.js';
import FullScreenDialog from '../common/fullScreenDialog.js';
import SafeRoomCheckList from './safeRoomCheckList.js';
import AttendantCheckList from './attendantChecklist.js';
import EscalationList from './escalationList.js'
import SyncIcon from '@material-ui/icons/Sync';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    },
    banner: {
        backgroundColor: 'yellow',
        fontSize: 'medium',
        textAlign: 'center',
        padding: '5px',
        color: 'red',
        cursor: 'pointer'
    }
}));

export default function PatientSittingList(props) {
    const classes = useStyles();
    const patientSittingRef = useRef();
    const safeRoomCheckListRef = useRef();
    const attendantCheckListRef = useRef();
    const escalationListRef = useRef();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { trainingMode, setTrainingMode } = useContext(Modules);
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [selectedLocation, setSelectedLocation] = useState(props.siteLocation ? props.siteLocation : []);
    const [locations, setLocations] = useState([]);
    const [open, setOpen] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [attendants, setAttendants] = useState([]);
    const [backDrop, setBackDrop] = useState(false);
    const [backDropCountAdd, setBackDropCountAdd] = useState(0);
    const [backDropCountSub, setBackDropCountSub] = useState(0);
    const [successMessage] = useState('');
    const [action, setAction] = useState('');
    const [patientSittingSelected, setPatientSittingSelected] = useState(null);
    const [deletePatientSittingSelected, setDeletePatientSittingSelected] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [isShowSafeRoomCheckList, setIsShowSafeRoomCheckList] = useState(false);
    const [isShowAttendantCheckList, setIsShowAttendantCheckList] = useState(false);
    const [disableWithStyle, setDisableWithStyle] = useState(true);
    const [disableWithAttendantCheckList, setDisableWithAttendantCheckList] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [isStartObservation, setIsStartObservation] = useState(false);
    const [isShowEscalations, setIsShowEscalations] = useState(false);
    const [isManager, setIsManager] = useState(false);
    const [safetyChecklistDto, setSafetyChecklistDto] = useState({});
    const [patientObservationAttendantDto, setPatientObservationAttendantDto] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [modified, setModified] = useState(false);
    const [patientSittingModalTitle, setPatientSittingModalTitle] = useState('');
    const [messageDialog] = useState("Are you sure to delete this item?");
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const posGroupId = defaultSite.IntegratedSystem.POSGroupId;
    const [patientSittingTypes] = useState(
        {
            statusList: [
                { Title: "All Status" },
                { Title: "Ready" },
                { Title: "Active" },
                { Title: "Delay" },
                { Title: "Pending Sign Off" },
                { Title: "Completed" },
                { Title: "Clinical Relief" },
                { Title: "Pending Assignment" }
            ],
            reasons: [
                { Title: "Shift Change" },
                { Title: "Break" },
                { Title: "Lunch" },
                { Title: "End of Break" },
                { Title: "End of Lunch" },
                { Title: "End of Observation" },
                { Title: "Other" }
            ],
            timeOfChecklists: [
                { Title: "A.M." },
                { Title: "P.M." },
                { Title: "Overnight" }
            ],
            mealsChecklists: [
                { Title: "Breakfast " },
                { Title: "Lunch" },
                { Title: "Dinner" },
                { Title: "N/A" }
            ]
        });

    const [filter, setFilter] = useState(
        {
            Date: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            Status: "All Status",
            Location: "",
            SuicideCheckBox: false,
            SafetyCheckBox: false,
            SuicideCount: 0,
            SafetyCount: 0,
            Total: 0,
            SiteId: defaultSite.id,
            StartDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            TrainingMode: trainingMode,
        });

    const [showObservation, setShowObservation] = useState(false);
    const [patientSittingsBase, setPatientSittingsBase] = useState([]);
    const [patientSittings, setPatientSittings] = useState({
        columns: [
            {                field: 'EscalationList', title: 'Escalations', width: '5%', render: rowData => rowData.EscalationList.length > 0 ? <Button variant="contained" color="secondary"><div escalation="true" >{rowData.EscalationList.length}</div></Button> : null,            },
            { field: 'Attendant', title: 'Attendant', width: '15%' },
            { field: 'PatientName', title: 'Patient', width: '5%' },
            { field: 'Requestor', title: 'Requestor', width: '10%' },
            { field: 'LocationPath', title: 'Location', width: '40%' },
            { field: (posGroupId === 1) ? 'Risk' : 'ObservationReasons', title: (posGroupId === 1) ? 'Risk' : 'Observation Reasons', width: '10%' },
            { field: 'StartDateString', title: 'Start', width: '10%' },
            { field: 'Status', title: 'Status', width: '10%' }
        ],
        data: []
    });

    const [escalationList, setEscalationList] = useState({
        columns: [
            { field: 'ObservationTimeString', title: 'Time' },
            { field: 'Observer', title: 'Observer' },
            { field: 'ObservationText', title: 'Observation', width: (posGroupId === 1) ? '25%' : '40%' },
            { field: 'InterventionText', title: 'Intervention', width: (posGroupId === 1) ? '25%' : '0%', hidden: (posGroupId === 2) },
            { field: 'LocationText', title: 'Location', width: (posGroupId === 1) ? '0%' : '20%', hidden: (posGroupId === 1) },
            { field: 'Comments', title: 'Comment', width: '10%', hidden: (posGroupId === 2) }
        ],
        data: []
    });

    const goToProductionMode = () => {
        setTrainingMode(false);
        props.history.push({ pathname: '/' });
    };

    const triggerSave = () => {
        patientSittingRef.current.save();
    };

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };
    const inputValueChanged = () => {
        setModified(true);
    };

    const getShortName = (name) => {
        if (name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
        setSelectedLocation([]);
    };

    const openAddPatientSitting = () => {
        if (!isManager) return;
        setOpen(true);
        setAction('New');
        setPatientSittingModalTitle("New Observation");
        setPatientSittingSelected(null);
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setFilter({ ...filter, Date: date });
        setSelectedDate(date);
    };

    const locationChanged = (e) => {

        setSelectedLocation(e);

        if (e.length > 0) {
            setFilter({ ...filter, Location: e[0]?.GeoLocationBranchName });
        }
        else {
            setFilter({ ...filter, Location: "" });
        }

        if (action === "New" || action === "Edit")
            patientSittingRef.current.valueChanged();
    };

    const closeAddPatientSitting = () => {
        setModified(false);
        TransactionTime.cancel();
        if (props.patientSittingSelected) {
            props.history.push({ pathname: '/PatientSittingList' });
        }
        else {
            setOpen(false);
            setAction('');
            setPatientSittingModalTitle("");
            setShowObservation(false);
            setIsStartObservation(false);
        }
        getPatientSittings();
    };

    const goToEdit = (rowData) => {
        setPatientSittingSelected(rowData);
        setOpen(true);
        setAction('Edit');
    };

    const handleRowClick = (event, rowData, isShowObservation) => {
        let escalation = event.target.getAttribute('escalation');
        let hasEle = escalation === "true" || event.target.querySelector('div');
        if (hasEle && rowData.EscalationList.length > 0) {
            setEscalationList({ ...escalationList, data: rowData.EscalationList });
            setIsShowEscalations(true);
        }
        else
            editPatientSitting(rowData, isShowObservation);
    }

    const editPatientSitting = (rowData, isShowObservation) => {

        //fill POSAttendantChecklist model
        setPatientObservationAttendantDto({ ...rowData.POSAttendantChecklist });

        if (rowData.Status === 'Completed' || (!rowData.ManagerUser && !isShowObservation)) {
            return;
        }

        if (isShowObservation && (rowData.Status === 'Ready' || rowData.Status === 'Delay' || rowData.Status === 'Scheduled' || rowData.Status === 'Pending Sign Off' || rowData.Status === "Clinical Relief")) {
            showStartObservation(rowData);
            return;
        }

        setShowObservation(isShowObservation);
        if (isShowObservation) {
            setPatientSittingModalTitle("Observation");
        }
        else {
            setPatientSittingModalTitle("Edit Observation");
        }

        goToEdit(rowData);

    };

    const showStartObservation = (rowData) => {
        if (rowData.Status === 'Active' || rowData.Status === "Completed" || rowData.Status === "Pending Sign Off") {
            return;
        }
        else if (rowData.Status === "Scheduled") {
            setErrorMessage("It's not time to start observing.");
            setOpenError(true);
            return;
        }
        else if (rowData.Status === "Pending Assignment") {
            setErrorMessage("Please assign attendant before starting the observation.");
            setOpenError(true);
            return;
        }

        setSafetyChecklistDto([]);
        setPatientSittingSelected(rowData);
        if ((posGroupId === 1) && (rowData.RiskClassificationId.indexOf("6") > -1 || rowData.RiskClassificationId.indexOf("7") > -1)) {
            setIsShowSafeRoomCheckList(true);
            return;
        }
        else if ((posGroupId === 2) && (rowData.SafetyCheckCount > 0) && (rowData.signHandOff.Reason === null || rowData.signHandOff.Reason === "Shift Change")) {
            setIsShowSafeRoomCheckList(true);
            return;
        }
        //if first time or trturning for a shift change
        if (rowData.POSAttendantChecklist.IsShowPOSAttendantChecklist) {
            setIsShowAttendantCheckList(true);
            return;
        }

        startObservation(rowData);

    };

    const startObservation = (item) => {

        if (item.Status === 'Active' || item.Status === "Completed" || item.Status === "Pending Sign Off") {
            return;
        }
        else if (item.Status === "Scheduled") {
            setErrorMessage("It's not time to start observing.");
            setOpenError(true);
            return;
        }
        else if (item.Status === "Pending Assignment") {
            setErrorMessage("Please assign attendant before starting the observation.");
            setOpenError(true);
            return;
        }

        setShowObservation(true);
        setIsShowSafeRoomCheckList(false);
        setIsStartObservation(true);
        setPatientSittingModalTitle("Observation");
        goToEdit(item);
    };

    const dialogConfirm = () => {
        submitDeletePatientSitting();
        dialogClose();
    };

    const dialogClose = () => {
        setOpenDialog(false);
    };

    const dialogOpen = () => {
        setOpenDialog(true);
    };

    const deletePatientSitting = (rowData) => {

        if ((rowData.Status !== 'Ready' && rowData.Status !== 'Scheduled') || !rowData.ManagerUser) {
            return;
        }
        setDeletePatientSittingSelected(rowData);
        dialogOpen();
    };

    const submitDeletePatientSitting = () => {
        setBackDrop(true);
        onBackDropCountFunc(1, 0);
        HttpService.post('/PatientSitting/DeletePatientSitting', deletePatientSittingSelected)
            .then((result) => {
                setLocations(result.data);
                setDeletePatientSittingSelected(null);
                onBackDropCountFunc(0, 1);
                getPatientSittings();
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getLocations = () => {
        setBackDrop(true);
        onBackDropCountFunc(1, 0);
        HttpService.post('/PatientSitting/GetGeoLocations', {
            siteId: defaultSite.id,
        })
            .then((result) => {
                setLocations(result.data);
                onBackDropCountFunc(0, 1);
                //setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };


    const getPatientSittings = () => {

        setBackDrop(true);
        onBackDropCountFunc(1, 0);
        HttpService.post('/PatientSitting/GetPatientSitting',
            {
                SiteId: filter.SiteId,
                StartDate: filter.StartDate,
                FilterDate: filter.Date,
                TrainingMode: filter.TrainingMode
            }
        )
            .then((result) => {
                setPatientSittingsBase(result.data);
                onBackDropCountFunc(0, 1);
                if (props.location.data) {
                    setOpen(true);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getRole = () => {

        HttpService.post('/PatientSitting/GetRole',

            {
                siteId: filter.SiteId
            }
        )
            .then((result) => {
                setIsManager(result.manager);
            },
                (error) => {
                    console.log(error);
                });
    };

    const getPOSAccountUsers = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetPOSAccountUsers', { siteId: defaultSite.id })
            .then((result) => {

                var attendants = result.data;
                attendants.push({ FirstName: "", LastName: "" });
                setAttendants(attendants);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const onBackDropCountFunc = (totalCount, count) => {

        setBackDropCountAdd(backDropCountAdd => backDropCountAdd + totalCount);
        setBackDropCountSub(backDropCountSub => backDropCountSub + count);
    };

    const filterPatientSittings = () => {

        let _filter = filter;
        _filter.SuicideCount = 0;
        _filter.SafetyCount = 0;
        _filter.Total = 0;

        let patientSittings0 = [];
        patientSittingsBase.forEach(function (item) {

            if (_filter.Status !== "All Status") {
                if (_filter.Status === item.Status) {
                    patientSittings0.push(item);
                }
            }
            else {
                patientSittings0.push(item);
            }
        });

        var patientSittings1 = [];
        patientSittings0.forEach(function (item) {

            if (_filter.Location === "All") {
                patientSittings1.push(item);
            }
            else if (_filter.Location !== "") {
                if (item.LocationPath.toLowerCase() === _filter.Location.toLowerCase()) {
                    patientSittings1.push(item);
                }
            }
            else
                patientSittings1.push(item);

        });


        var patientSittings2 = [];
        patientSittings1.forEach(function (item) {

            if (_filter.SuicideCheckBox || _filter.SafetyCheckBox) {
                if (_filter.SuicideCheckBox && item.Risk === "High Risk") {
                    patientSittings2.push(item);
                }
                else if (_filter.SafetyCheckBox && item.Risk === "Moderate/Lower Risk") {
                    patientSittings2.push(item);
                }
            }
            else {
                patientSittings2.push(item);
            }
        });

        patientSittings2.forEach(function (item) {

            if (item.Risk === "Moderate/Lower Risk") {
                _filter.SafetyCount++;
            }
            else if (item.Risk === "High Risk") {
                _filter.SuicideCount++;
            }

        });


        _filter.Total = patientSittings2.length;
        setPatientSittings({ ...patientSittings, data: patientSittings2 });
        setFilter(_filter);
    };

    useEffect(() => {
        if (props.location.data) {
            setAction('Edit');
            setSelectedLocation(props.location.location);
        }
        else {
            getLocations();
        }
        getRole();
        getPOSAccountUsers();
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (action === "") {
            getPatientSittings();
        }
        // eslint-disable-next-line 
    }, [selectedDate]);

    useEffect(() => {
        if (backDropCountAdd !== 0 && backDropCountAdd === backDropCountSub) {
            setBackDrop(false);
        }
    }, [backDropCountAdd, backDropCountSub]);


    useEffect(() => {
        if (action === "") {
            filterPatientSittings();
        }
        // eslint-disable-next-line 
    }, [patientSittingsBase, filter.Status, filter.Location, filter.SuicideCheckBox, filter.SafetyCheckBox]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="patientSittingBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <AlertDialog handleClose={dialogClose} handlePositive={dialogConfirm} open={openDialog} message={messageDialog}></AlertDialog>
                <ContentDialog open={isShowSafeRoomCheckList} title={(posGroupId === 1) ? "Safe Room Checklist for High/Moderate Suicide Risk Patients" : "SAFE ROOM ENVIRONMENT CHECKLIST"} maxWidth={"lg"} disableWithStyle={disableWithStyle} close={() => setIsShowSafeRoomCheckList(false)} onConfirm={() => { safeRoomCheckListRef.current.save(); }}>
                    <SafeRoomCheckList ref={safeRoomCheckListRef} patientSittingSelected={patientSittingSelected} onSafetyChecklistSave={(Safetydto) => { setSafetyChecklistDto(Safetydto); }} onDisableWithStyle={(disable) => { setDisableWithStyle(disable) }}
                        onAttendantCheckListShow={(isShow) => { setIsShowAttendantCheckList(isShow); }} startObservation={startObservation}></SafeRoomCheckList>
                </ContentDialog>
                <ContentDialog open={isShowAttendantCheckList} closeName={'Decline'} confirmName={'Accept'} title="Patient Observation Attendant Checklist" styleTitle={{ color: '#4183c4' }} maxWidth={"lg"} disableWithStyle={disableWithAttendantCheckList} close={() => { attendantCheckListRef.current.cancel(); setIsShowAttendantCheckList(false); }} onConfirm={() => { attendantCheckListRef.current.save(); }}>
                    <AttendantCheckList ref={attendantCheckListRef} attendants={attendants} selectPatientObservationAttendantDto={patientObservationAttendantDto} safetyChecklistDto={safetyChecklistDto} patientSittingSelected={patientSittingSelected} onDisableWithStyle={(disable) => { setDisableWithAttendantCheckList(disable) }} startObservation={startObservation} isManuallyShowAttendantCheckList={false} close={() => setIsShowAttendantCheckList(false)}></AttendantCheckList>
                </ContentDialog>
                <FullScreenDialog open={isShowEscalations} title="Escalations" hideConfirm={true} maxWidth={"lg"} close={() => setIsShowEscalations(false)} currentTheme={currentTheme}>
                    <EscalationList ref={escalationListRef} escalationList={escalationList}></EscalationList>
                </FullScreenDialog>
                <FullScreenDialog open={open} title={patientSittingModalTitle} save={isManager && patientSittingModalTitle !== "Observation"} hideConfirm={true} maxWidth={"lg"} close={() => closeAddPatientSitting()} onConfirm={triggerSave} currentTheme={currentTheme} >
                    <PatientSittingAdd ref={patientSittingRef}
                        parentCallback={closeAddPatientSitting}
                        refreshGrid={getPatientSittings}
                        locations={locations}
                        showObservation={showObservation}
                        isStartObservation={isStartObservation}
                        patientSittingSelected={patientSittingSelected}
                        theme={currentTheme}
                        patientSittings={patientSittings.data}
                        isManager={isManager}
                        attendants={attendants}
                        trainingMode={trainingMode}
                        inputValueChanged={inputValueChanged}
                    />
                </FullScreenDialog>


                {trainingMode && <div className={classes.banner}><Link to="/#" onClick={goToProductionMode}>Training mode - Click here to return to Production</Link></div>}

                <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                    <Toolbar>
                        <SmallMenu moduleName={"PatientSitting"} modified={modified} saveCallback={triggerSave} />
                        <Grid container direction="row" alignItems="center">
                            <Grid item>
                                <Typography variant="h6" >
                                    {
                                        !open &&
                                        <Link to="/" className="nav-text">
                                            TeamLead
                                        </Link>
                                    }
                                    {
                                        open &&
                                        <span onClick={triggerSave} className="nav-text">
                                            TeamLead
                                        </span>
                                    }
                                    / Patient Observation / {action} Observations
                                </Typography>
                            </Grid>
                            <Grid item>
                                <StatusIcon />
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-end" spacing={2}>

                            {open &&
                                <Fab style={{ background: currentTheme.secondary, color: 'white' }} size="small" aria-label="close" onClick={closeAddPatientSitting}>
                                    <CloseIcon />
                                </Fab>
                            }
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Card color="primary" className="page-container" style={{ background: currentTheme.background }}>
                    {!open &&
                        <CardBody className={'ml-auto'} style={{ marginTop: "50px" }}>
                            {
                                isManager &&
                                <Link to={{ pathname: "/ObservationDashboard" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="mr-2"
                                        style={{ background: currentTheme.secondary }}
                                    >
                                        Go To Observation Dashboard
                                    </Button>
                                </Link>
                            }
                            <Button color="primary" style={{ background: isManager ? currentTheme.secondary : '#bdb7b7', color: 'white' }}
                                size="small" disabled={!isManager} onClick={openAddPatientSitting}
                                className="mr-2"
                            >
                                New Observation
                            </Button>
                        </CardBody>
                    }
                    <CardBody style={{ color: currentTheme.text }}>
                        <div className={classes.root} autoComplete="off">

                            {!open &&
                                <>
                                    <Grid container direction="row" spacing={1}>
                                        <Grid item xs={12} sm={4}>
                                            <div className={'mb-2'}>Date</div>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker fullWidth disableToolbar autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    disableFuture="true"
                                                    value={selectedDate}
                                                    onChange={date => dateChanged(date)}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>

                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" spacing={1}>
                                        <Grid item xs={12} sm={4}>
                                            <div>Status</div>
                                            <FormControl fullWidth variant="outlined" margin="dense" className={classes.ddl}>
                                                <Select
                                                    native
                                                    size="small"
                                                    value={filter.Status}
                                                    onChange={(e) => { setFilter({ ...filter, Status: e.target.value }); }}
                                                >
                                                    <option aria-label="None" key="0" value="0" />
                                                    {
                                                        patientSittingTypes.statusList.map((option, key) => {
                                                            return <option key={option.Title} value={option.Title} label={option.Title} >{option.Title}</option>;
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <div className={'mb-2'}>Location</div>
                                            <Typeahead
                                                style={{ color: (action === "Edit" ? "black" : "") }}
                                                id="LocationList"
                                                labelKey="GeoLocationBranchName"
                                                placeholder="Choose a Location..."
                                                options={locations}
                                                selected={selectedLocation}
                                                disabled={action === "Edit"}
                                                onChange={(e) => locationChanged(e)}
                                                renderMenuItemChildren={(option, key) => (
                                                    <>
                                                        <div className="dropdown-widget">
                                                            <div className="left">{getShortName(option.GeoLocationBranchName)}</div>
                                                        </div>
                                                    </>
                                                )}
                                            />

                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={3}>
                                        <Grid item xs={12} sm={6}>
                                            {(posGroupId === 1) &&
                                                <>
                                                    <FormControlLabel
                                                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                                        value="end"
                                                        control={<><Checkbox color="primary" checked={filter.SuicideCheckBox} onChange={e => setFilter({ ...filter, SuicideCheckBox: e.target.checked })} /> <StopIcon style={{ color: 'red' }}></StopIcon></>}
                                                        label="High Risk:"
                                                        labelPlacement="end"
                                                    />
                                                    <span>{filter.SuicideCount}</span>
                                                    <FormControlLabel
                                                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                                        value="end"
                                                        control={<><Checkbox color="primary" checked={filter.SafetyCheckBox} onChange={e => setFilter({ ...filter, SafetyCheckBox: e.target.checked })} /> <StopIcon style={{ color: '#f9fa61' }}>></StopIcon></>}
                                                        label="Moderate/Lower Risk:"
                                                        labelPlacement="end"
                                                    />
                                                    <span>{filter.SafetyCount}</span>
                                                </>
                                            }
                                        </Grid>
                                        <Grid item container xs={12} sm={6} spacing={3} justify="flex-end">
                                            <SyncIcon fontSize="small" style={{ cursor: 'pointer', color: currentTheme.secondary }} onClick={getPatientSittings} />
                                            <span>Total: </span>
                                            <span>{filter.Total}</span>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            {!open &&
                                <div className="material-table">
                                    <MaterialTable
                                        title=""
                                        columns={patientSittings.columns}
                                        data={patientSittings.data}
                                        onRowClick={(event, rowData) => { handleRowClick(event, rowData, true); }}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: "55vh", maxBodyHeight: "55vh",
                                            headerStyle: {
                                                fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: 'white',
                                            },
                                            rowStyle: rowStyle
                                        }}
                                        actions={[
                                            rowData => ({
                                                icon: () => (<PowerSettingsNewIcon style={{ color: (rowData.Status !== 'Ready' && rowData.Status !== 'Delay' && rowData.Status !== 'Clinical Relief') ? '#bdb7b7' : 'inherit' }} />),
                                                tooltip: 'Start Observation',
                                                onClick: (event, rowData) => { showStartObservation(rowData); }
                                            }),
                                            rowData => ({
                                                icon: 'edit',
                                                iconProps: { color: (rowData.Status === 'Completed' || !rowData.ManagerUser) ? 'disabled' : 'inherit' },
                                                tooltip: 'Edit Observation',
                                                onClick: (event, rowData) => { editPatientSitting(rowData, false); }
                                            }),
                                            rowData => ({
                                                icon: 'delete',
                                                iconProps: { color: ((rowData.Status !== 'Ready' && rowData.Status !== 'Scheduled') || !rowData.ManagerUser) ? 'disabled' : 'inherit' },
                                                tooltip: 'Delete Observation',
                                                onClick: (event, rowData) => { deletePatientSitting(rowData); }
                                            })
                                        ]}
                                    />
                                </div>

                            }
                        </div>

                        {/*<div style={{ maxWidth: '100%' }}>*/}


                        {/*    {open && <PatientSittingAdd ref={patientSittingRef}*/}
                        {/*        parentCallback={closeAddPatientSitting}*/}
                        {/*        refreshGrid={getPatientSittings}*/}
                        {/*        locations={locations}*/}
                        {/*        showObservation={showObservation}*/}
                        {/*        isStartObservation={isStartObservation}*/}
                        {/*        patientSittingSelected={patientSittingSelected}*/}
                        {/*        theme={currentTheme}*/}
                        {/*        patientSittings={patientSittings.data}*/}
                        {/*        isManager={isManager}*/}
                        {/*        attendants={attendants}*/}
                        {/*        trainingMode={trainingMode}*/}
                        {/*        inputValueChanged={inputValueChanged}*/}
                        {/*    />*/}
                        {/*    }*/}


                        {/*</div>*/}
                    </CardBody>
                </Card>

            </ThemeProvider>
        </React.Fragment>
    )
}
